import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-026b2c44"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail-title" }
const _hoisted_2 = { class: "detail-refuse" }
const _hoisted_3 = { class: "refuse-input" }
const _hoisted_4 = { class: "text-rt" }

import { t } from '@/plugins/i18n'
import { ref, reactive } from 'vue'
import { refusedBillApi } from '@/apis/fund'
import { ElMessageBox, ElMessage } from 'element-plus'
import { useStore } from 'vuex'

export default /*#__PURE__*/_defineComponent({
  props: ['type'],
  emits: ['submit'],
  setup(__props, { expose, emit }) {

const props = __props

const store = useStore()
const isSub = store.getters.isSub
let item: any = {}
const visible = ref(false)
const loading = ref(false)
const customerRefusedReason = ref('')

const open = (record: any) => {
  item = record
  visible.value = true
}
const close = () => {
  customerRefusedReason.value = ''
  visible.value = false
}
const submit = () => {
  if (!customerRefusedReason.value) {
    ElMessage.warning(t('请输入拒绝原因'))
    return
  }
  loading.value = true
  refusedBillApi({
    customerBillId: item.customerBillId,
    customerRefusedReason: customerRefusedReason.value,
    mainOrSubBill: props.type !== '2'
  }).then((res: any) => {
    loading.value = false
    if (res.success) {
      ElMessage.success(t('操作成功'))
      store.dispatch('bill/getBillNum')
      close()
      emit('submit')
    }
  })
}
expose({ open })

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    "destroy-on-close": "",
    modelValue: visible.value,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((visible).value = $event)),
    "custom-class": "a-detail-r flex",
    onClose: close
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, _toDisplayString(_unref(t)('提示')), 1),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_el_input, {
            modelValue: customerRefusedReason.value,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((customerRefusedReason).value = $event)),
            rows: 6,
            type: "textarea",
            placeholder: _unref(t)('请输入拒绝原因'),
            maxlength: 100,
            class: "textarea"
          }, null, 8, ["modelValue", "placeholder"])
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_el_button, {
          type: "default",
          onClick: close,
          class: "btn"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('取消')), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_button, {
          type: "primary",
          onClick: submit,
          class: "btn",
          loading: loading.value
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('提交')), 1)
          ]),
          _: 1
        }, 8, ["loading"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue"]))
}
}

})